export const PATIENT_RESPONSE_CHECKBOX_ID = "patient-response-toggle";
